<template>
  <div>
    <v-row>
      <v-col>
        <p class="font-weight-bold black--text quotation-title mb-7">
          Local de Risco
        </p>
      </v-col>
      <v-spacer />
      <QuotationFloatActionButton
        class="messageInfoRisk"
        v-if="getUserIsGuest || !getIsEmployeeUser"
        :message="infoMessage"
      />
    </v-row>
    <v-form ref="form" @submit.prevent="submit" v-model="formValid">
      <v-row>
        <v-col cols="12" sm="6" md="2" class="pr-0 pr-md-5">
          <BaseFormInput
            id-element="cepLocation"
            placeholder="Digite o cep"
            required
            v-model="form.endereco.cep"
            :rules="[requiredInput, isValidCep]"
            validate-on-blur
            v-facade="maskCEP"
            label-text="CEP"
            @keyup="searchInput"
            :cep="cepInputClass"
          />
        </v-col>
        <v-col cols="12" sm="6" md="4" class="pr-0 pr-md-5">
          <BaseFormInput
            id-element="cityLocation"
            placeholder=""
            required
            v-model="form.endereco.cidade"
            :rules="[requiredInput]"
            label-text="Município"
            disabled
          />
        </v-col>
        <v-col cols="12" sm="6" md="3" class="pr-0 pr-sm-5">
          <BaseFormInput
            id-element="ufLocation"
            placeholder=""
            required
            :items="brazilianStates"
            v-model="form.endereco.uf.sigla"
            :rules="[requiredInput]"
            label-text="UF"
            item-text="nome"
            item-value="sigla"
            :return-object="true"
            disabled
          />
        </v-col>
      </v-row>
    </v-form>
    <v-divider class="pb-6" />
    <v-row class="pb-6">
      <QuotationRiskItemAgricola
        :form="this.form"
        :subProduct="subProduct"
        v-if="productIsAgricola"
        class="col col-lg-12"
      />
      <QuotationRiskItemCafezal
        :form="this.form"
        v-if="productIsCafezal"
        class="col col-lg-12"
      />
    </v-row>
  </div>
</template>

<script>
import { requiredInput, dateTermValid, isValidCep } from "@/utils/rules.js";
import { maskDate, maskCEP } from "@/utils/masks.js";
import { mapActions, mapState } from "vuex";
import { brazilianStates } from "@/utils/utils.js";
import { LoadingRequest } from "@/mixins/LoadingMixin";
import QuotationRiskItemAgricola from "../components_agro/QuotationRiskItemAgricola.vue";
import QuotationRiskItemCafezal from "../components_agro/QuotationRiskItemCafezal.vue";
import QuotationFloatActionButton from "../components_agro/QuotationFloatActionButton.vue";

export default {
  components: {
    QuotationRiskItemAgricola,
    QuotationRiskItemCafezal,
    QuotationFloatActionButton
  },
  data: () => ({
    formValid: true,
    loading: false,
    maskDate,
    requiredInput,
    dateTermValid,
    isValidCep,
    maskCEP,
    brazilianStates,
    showCepErro: false
  }),
  props: {
    form: {
      type: Object
    },
    product: {
      type: String
    },
    subProduct: {
      type: Object
    }
  },
  mixins: [LoadingRequest],
  methods: {
    ...mapActions("quotation", ["requestAddressApi"]),
    ...mapActions(["hasLoading", "showAlertNotification"]),
    aboveZero(value) {
      return value > 0 || "O valor deve ser maior do que 0.";
    },
    searchInput(cep) {
      if (cep.target.value.length === 9) {
        this.fetchAddressApi(cep);
      }
    },
    async fetchAddressApi(value) {
      const cep = value.target.value.replace(/[^0-9]/g, "");
      try {
        const result = await this.withLoading(this.requestAddressApi(cep));
        const cepFormatado = `${result.cep.slice(0, 5)}-${result.cep.slice(5)}`;
        this.form.endereco.cep = cepFormatado;
        this.form.endereco.cidade = result.cidade;
        this.form.endereco.uf.sigla = result.uf.sigla;
      } catch (error) {
        this.form.endereco.cep = "";
        this.form.endereco.cidade = "";
        this.form.endereco.uf.sigla = "";
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        if (!this.form.enderedo.cep) {
          this.showCepErro = true;
          return;
        }

        const item = this.addressApi.find(x => x.id == this.value.id);
        this.value.id = item?.nome == this.value.nome ? this.value.id : null;
        this.$emit("submit", this.value);
      }
    }
  },
  computed: {
    ...mapState(["loadingStatus"]),
    ...mapState("quotation", ["addressApi"]),
    ...mapState("me", ["userIsEmployee", "userIsGuest"]),
    formLocation: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    cepInputClass() {
      return this.showCepErro ? "red-border-class" : "";
    },
    productIsCafezal() {
      return this.product === "cafezal";
    },
    productIsAgricola() {
      return this.product === "agricola";
    },
    getUserIsGuest() {
      return this.userIsGuest;
    },
    getIsEmployeeUser() {
      return this.userIsEmployee;
    },
    infoMessage() {
      return "Insira o CEP referente às áreas (propriedades), e, em seguida, adicione as áreas clicando no botão Adicionar Área e Gravar Área (ao final da página). Para prosseguir é necessário ao menos uma área.";
    }
  },
  "form.endereco.cep": {
    handler(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.form.endereco.cidade = "";
        this.form.endereco.uf.sigla = "";
      }
    }
  }
};
</script>
<style lang="sass">
.messageInfoRisk
  margin-top: -70px
</style>
